/* hdnywholesale — collection page behaviour */
(function () {
  'use strict';

  var root = document.querySelector('[data-hdny-collection]');
  if (!root) return;

  var pack = parseInt(root.dataset.pack, 10) || 1;
  var loggedIn = root.dataset.loggedIn === 'true';
  var money = root.dataset.moneyFormat || '${{amount}}';

  function fmt(cents) {
    var v = (cents / 100).toFixed(2);
    return money
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var rail = root.querySelector('[data-hdny-rail]');
  var scrim = document.querySelector('[data-hdny-scrim]');
  var fbtn = root.querySelector('[data-hdny-fbtn]');
  var sheet = document.querySelector('[data-hdny-sheet]');

  function isSheetOpen() { return !!sheet && sheet.classList.contains('is-on'); }
  function toggleScrim(on) {
    if (!scrim) return;
    scrim.classList.toggle('is-on', !!on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }
  function closeRail() {
    if (!rail) return;
    rail.classList.remove('is-on');
    if (!isSheetOpen()) toggleScrim(false);
  }
  if (fbtn && rail) {
    fbtn.addEventListener('click', function () {
      rail.classList.add('is-on');
      toggleScrim(true);
    });
  }

  /* ---------- sort ---------- */
  var sort = root.querySelector('[data-hdny-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- show more inside a group ---------- */
  root.querySelectorAll('[data-hdny-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-hdny-group]');
      if (!group) return;
      var hidden = group.querySelectorAll('.hdny-col__hidden');
      if (hidden.length) {
        hidden.forEach(function (el) { el.classList.remove('hdny-col__hidden'); });
        btn.textContent = btn.dataset.less || 'Show fewer';
      } else {
        group.querySelectorAll('[data-hdny-opt]').forEach(function (el, i) {
          if (i >= 8) el.classList.add('hdny-col__hidden');
        });
        btn.textContent = btn.dataset.more || 'Show all';
      }
    });
  });

  /* ---------- facets ---------- */
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hdny-card]'));
  var countEl = root.querySelector('[data-hdny-count]');
  var chipsEl = root.querySelector('[data-hdny-chips]');
  var clearEl = root.querySelector('[data-hdny-clear]');
  var noneEl = root.querySelector('[data-hdny-noresults]');
  var codeIn = root.querySelector('[data-hdny-code]');
  var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-hdny-facet]'));

  cards.forEach(function (card) {
    card._models = (card.dataset.models || '').split('||').filter(Boolean);
    card._style = card.dataset.style || '';
    card._stock = card.dataset.stock === '1';
    card._new = card.dataset.new === '1';
    card._hay = ((card.dataset.code || '') + ' ' + (card.dataset.title || '')).toLowerCase();
  });

  function selected(kind) {
    return boxes.filter(function (b) { return b.dataset.hdnyFacet === kind && b.checked; })
      .map(function (b) { return b.value; });
  }

  function apply() {
    var models = selected('model');
    var styles = selected('style');
    var avail = selected('avail');
    var q = codeIn ? codeIn.value.trim().toLowerCase() : '';
    var shown = 0;

    cards.forEach(function (card) {
      var ok = true;
      if (models.length) {
        ok = models.some(function (m) { return card._models.indexOf(m) !== -1; });
      }
      if (ok && styles.length) ok = styles.indexOf(card._style) !== -1;
      if (ok && avail.indexOf('stock') !== -1) ok = card._stock;
      if (ok && avail.indexOf('new') !== -1) ok = card._new;
      if (ok && q) ok = card._hay.indexOf(q) !== -1;

      card.hidden = !ok;
      if (ok) shown++;
    });

    if (countEl) countEl.textContent = shown;
    if (noneEl) noneEl.hidden = shown !== 0 || cards.length === 0;

    var chips = [];
    models.forEach(function (v) { chips.push(['model', v, v]); });
    styles.forEach(function (v) { chips.push(['style', v, v]); });
    avail.forEach(function (v) {
      chips.push(['avail', v, v === 'stock' ? 'In stock only' : 'New arrivals']);
    });
    if (q) chips.push(['code', '', codeIn.value.trim()]);

    if (chipsEl) {
      chipsEl.innerHTML = chips.map(function (c) {
        return '<button type="button" class="hdny-col__chip" data-hdny-rm="' + c[0] + '" data-hdny-val="' + esc(c[1]) + '">' +
          esc(c[2]) +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      }).join('');
    }
    if (clearEl) clearEl.hidden = chips.length === 0;
  }

  boxes.forEach(function (b) { b.addEventListener('change', apply); });
  if (codeIn) codeIn.addEventListener('input', apply);

  if (chipsEl) {
    chipsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hdny-rm]');
      if (!btn) return;
      var kind = btn.dataset.hdnyRm;
      var val = btn.dataset.hdnyVal;
      if (kind === 'code') {
        codeIn.value = '';
      } else {
        boxes.forEach(function (b) {
          if (b.dataset.hdnyFacet === kind && b.value === val) b.checked = false;
        });
      }
      apply();
    });
  }

  if (clearEl) {
    clearEl.addEventListener('click', function () {
      boxes.forEach(function (b) { b.checked = false; });
      if (codeIn) codeIn.value = '';
      apply();
    });
  }

  apply();

  /* ---------- variant sheet ---------- */
  var sheetTitle = sheet && sheet.querySelector('[data-hdny-sheet-title]');
  var sheetBody = sheet && sheet.querySelector('[data-hdny-sheet-body]');
  var sheetTot = sheet && sheet.querySelector('[data-hdny-sheet-total]');
  var sheetPcs = sheet && sheet.querySelector('[data-hdny-sheet-pcs]');
  var sheetAdd = sheet && sheet.querySelector('[data-hdny-sheet-add]');

  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-on');
    sheet.setAttribute('aria-hidden', 'true');
    if (!rail || !rail.classList.contains('is-on')) toggleScrim(false);
  }

  function updateTotal() {
    if (!sheetBody) return;
    var pcs = 0, cents = 0;
    sheetBody.querySelectorAll('input[data-hdny-vid]').forEach(function (i) {
      var n = parseInt(i.value, 10) || 0;
      pcs += n;
      cents += n * (parseInt(i.dataset.hdnyPrice, 10) || 0);
    });
    sheetPcs.textContent = pcs + (pcs === 1 ? ' pc' : ' pcs');
    sheetTot.textContent = loggedIn ? fmt(cents) : '\u2014';
  }

  function openSheet(card) {
    if (!sheet || !card) return;
    var raw = card.querySelector('[data-hdny-variants]');
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw.textContent); } catch (err) { return; }

    sheetTitle.textContent = card.dataset.title + (card.dataset.code ? ' \u00b7 ' + card.dataset.code : '');

    var groups = {}, order = [];
    data.forEach(function (v) {
      var g = v.model || 'All models';
      if (!groups[g]) { groups[g] = []; order.push(g); }
      groups[g].push(v);
    });

    sheetBody.innerHTML = order.map(function (g) {
      return '<div class="hdny-sheet__group">' + esc(g) + '</div>' + groups[g].map(function (v) {
        var dot = '<i class="hdny-sheet__dot" style="background:' + (v.swatch ? esc(v.swatch) : 'var(--hdny-paper-2)') + '"></i>';
        var stock = v.available ? (v.qty > 0 ? v.qty + ' pcs' : 'In stock') : 'Out of stock';
        var qty = v.available && loggedIn
          ? '<div class="hdny-qty">' +
              '<button type="button" data-hdny-step="-1" aria-label="Decrease">&minus;</button>' +
              '<input type="number" min="0" step="' + pack + '" value="0" inputmode="numeric" aria-label="Quantity" ' +
                'data-hdny-vid="' + v.id + '" data-hdny-price="' + v.price + '">' +
              '<button type="button" data-hdny-step="1" aria-label="Increase">+</button>' +
            '</div>'
          : '<span class="hdny-col-mono" style="font-size:11.5px;color:var(--hdny-slate)">' +
              (v.available ? 'Log in' : 'Sold out') + '</span>';
        return '<div class="hdny-sheet__row' + (v.available ? '' : ' hdny-sheet__row--out') + '">' +
          '<span class="hdny-sheet__vname">' + dot +
            '<span><strong>' + esc(v.colour || v.title) + '</strong>' +
            '<small>' + esc(v.sku || '') + (v.sku ? ' \u00b7 ' : '') + stock + '</small></span>' +
          '</span>' + qty + '</div>';
      }).join('');
    }).join('');

    sheetAdd.textContent = loggedIn ? 'Add to cart' : 'Log in to order';
    sheetAdd.disabled = false;
    updateTotal();

    sheet.classList.add('is-on');
    sheet.setAttribute('aria-hidden', 'false');
    toggleScrim(true);
  }

  root.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-hdny-pick]');
    if (pick) {
      e.preventDefault();
      openSheet(pick.closest('[data-hdny-card]'));
    }
  });

  if (sheetBody) {
    sheetBody.addEventListener('click', function (e) {
      var step = e.target.closest('[data-hdny-step]');
      if (!step) return;
      var input = step.parentElement.querySelector('input');
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.hdnyStep, 10) * pack);
      updateTotal();
    });
    sheetBody.addEventListener('input', updateTotal);
  }

  if (sheetAdd) {
    sheetAdd.addEventListener('click', function () {
      if (!loggedIn) { window.location.href = '/account/login'; return; }
      var items = [];
      sheetBody.querySelectorAll('input[data-hdny-vid]').forEach(function (i) {
        var n = parseInt(i.value, 10) || 0;
        if (n > 0) items.push({ id: parseInt(i.dataset.hdnyVid, 10), quantity: n });
      });
      if (!items.length) return;

      sheetAdd.disabled = true;
      sheetAdd.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || 'Could not add to cart');
          sheetAdd.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'hdny-collection' } }));
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('.cart-bubble__text, [data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          setTimeout(closeSheet, 700);
        })
        .catch(function (err) {
          sheetAdd.textContent = String(err.message).slice(0, 40) || 'Try again';
        })
        .finally(function () {
          setTimeout(function () {
            sheetAdd.disabled = false;
            sheetAdd.textContent = loggedIn ? 'Add to cart' : 'Log in to order';
          }, 1400);
        });
    });
  }

  if (sheet) {
    sheet.querySelector('[data-hdny-sheet-close]').addEventListener('click', closeSheet);
  }
  if (scrim) {
    scrim.addEventListener('click', function () { closeSheet(); closeRail(); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSheet(); closeRail(); }
  });
})();
